<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{cardLabel}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <template v-if="selected">
                    <div class="text-sm font-bold">{{selected.data.nom}}</div>
                    <div class="text-xs font-light">{{selected.data.adresse + ' ' + selected.data.cp + ' ' + selected.data.ville}}</div>
                </template>
            </template>

            <template v-slot:open>
                <sav-spinner class="mt-4" v-if="loading" :size="10" />

                <div v-if="!loading" :class="selectedStation ? '' : 'lg:flex'">
                    <div class="p-2 pl-0" :class="selectedStation ? '' : 'lg:w-1/2'">
                        <div ref="leftSide" :style="selectedStation ? '' : 'max-height: 400px; overflow-y: auto'">
                            <!-- No stations -->
                            <div class="p-4 font-light text-white bg-red-600 rounded-xl" v-if="data && data.length <= 0">
                                <i class="mr-2 fas fa-triangle-exclamation"></i> {{$t('form.stations.aucune_station_n_a_ete_trouve')}}
                            </div>

                            <!-- Stations list -->
                            <div class="animate__slideInLeft animate__animated animate__faster" v-if="!selectedStation">
                                <div
                                v-for="(marker, markerIndex) in markers"
                                :key="'marker-' + markerIndex"
                                :class="markerIndex == markers.length - 1 ? '' : 'border-b-4'"
                                class="p-3 duration-200 border-gray-200 rounded cursor-pointer hover:bg-gray-100"
                                >
                                    <!-- Station card -->
                                    <div
                                    @mouseover="selectedMarker = marker"
                                    @mouseleave="selectedMarker = null"
                                    @click.stop="selectMarker(marker)" class="px-2">
                                        <div class="flex items-center justify-between">
                                            <div>
                                                <div class="text-sm font-bold">{{marker.data.nom}}</div>
                                                <div class="xl:flex xl:items-center" :class="marker.data.distance ? 'mt-1.5 mb-1' : ''">
                                                    <div>
                                                        <!-- Distance -->
                                                        <sav-distance v-if="marker.data.distance" :label="false" :distance="marker.data.distance + ' km'" />

                                                        <!-- Price -->
                                                        <div v-if="marker.data.accompte && marker.data.accompte > 0" class="pt-2 mt-1 text-xs font-light text-red-500 xl:mt-0">
                                                            {{$t('form.stations.accompte')}}: {{marker.data.accompte}} €
                                                            <div v-if="marker.data.mo > 0">{{$t('form.stations.main_d_oeuvre')}}: {{marker.data.mo}} €</div>
                                                            <div v-if="marker.data.deplacement > 0">{{$t('form.stations.deplacement')}}: {{marker.data.deplacement}} €</div>
                                                            <div v-if="marker.data.devis_ref > 0">{{$t('form.stations.devis_refuse')}}: {{marker.data.devis_ref}} €</div>
                                                            <div class="pt-2 mt-2 text-xs font-light border-t border-gray-200" v-if="marker.data.comment">{{marker.data.comment}}</div>
                                                        </div>
                                                        <div v-else-if="$formTool.getFormData('proc').type_garantie == 'hors_garantie'">
                                                            <div class="mt-2 mr-5 text-xs font-light text-orange-600">
                                                                <i class="mr-1 fas fa-triangle-exclamation"></i> {{$t('form.stations.tarifs_non_communiques_des_frais_sont_a_prevoir')}}
                                                            </div>
                                                        </div>
                                                        <div v-if="$formTool.getFormData('proc').type_garantie == 'hors_garantie' && marker.data.qualirepar > 0" class="text-xs font-light text-green-600">{{$t('form.stations.bonus_reparation')}}: -{{marker.data.qualirepar}} €</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Station Informations -->
                            <div v-if="selectedStation">
                                <!-- Nom -->
                                <div class="pb-3 mb-3 border-b">
                                    <div class="items-center justify-between">
                                        <div>
                                            <div class="text-xl font-bold">{{selectedStation.data.nom}}</div>
                                            <div class="text-xs font-light" v-if="selectedStation.data.distance > 0">{{selectedStation.data.distance}} km</div>
                                        </div>
                                        <div v-if="$formTool.getFormData('proc').type_garantie == 'hors_garantie'" class="flex items-center">
                                            <star-rating
                                            v-if="selectedStation && selectedStation.google && selectedStation.google.rating"
                                            class="mt-1 mb-4"
                                            v-model="selectedStation.google.rating"
                                            :read-only="true"
                                            :increment="0.1"
                                            :star-size="20"
                                            text-class="hidden"
                                            ></star-rating>
                                            <small v-if="selectedStation && selectedStation.google" class="text-xs">{{selectedStation.google.user_ratings_total}} avis</small>
                                        </div>
                                        <div class="flex mt-3">
                                            <button class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-600 hover:bg-green-700 rounded-xl font-extrabold mr-2" @click="end(selectedStation)" test-id="btn-valid-station">
                                                <i class="mr-1 fas fa-check"></i> {{$t('form.stations.confirmer_la_station')}}
                                            </button>
                                            <button class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-red-600 border-red-600 hover:bg-red-700 text-white font-extrabold rounded-xl opacity-80 hover:opacity-100 duration-200" @click="selectedStation = null" test-id="btn-submit">
                                                <i class="mr-1 fas fa-times"></i> {{$t('form.stations.annuler')}}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <template v-if="!canDisplayStationInfos">
                                    <sav-spinner class="mt-4" :size="10" />
                                </template>
                                <template v-if="canDisplayStationInfos">
                                    <!-- map -->
                                    <div class="mt-4">
                                        <div class="text-sm font-bold">
                                            <i class="mr-1 fas fa-location-dot"></i> {{$t('form.stations.emplacement')}}
                                        </div>
                                        <sav-map
                                        class="w-full mt-2 mb-5"
                                        height="250"
                                        custom-class="shadow my-rounded"
                                        v-if="markers && markers.length > 0"
                                        :position="{
                                            longitude: selectedStation.longitude,
                                            latitude: selectedStation.latitude,
                                            zoom: zoom
                                        }"
                                        :markers="[selectedStation]"
                                        :selected-marker="selectedStation"
                                        @marker-clicked="markerClicked"
                                        ></sav-map>
                                    </div>

                                    <!-- Tarifs -->
                                    <div class="mt-4">
                                        <div class="text-sm font-bold">
                                            <i class="mr-1 fas fa-euro"></i> {{$t('form.stations.tarifs')}}
                                        </div>
                                        <div class="p-5 mt-2 text-sm border rounded-xl">
                                            <div v-if="(Number(selectedStation.data.mo) + Number(selectedStation.data.deplacement) + Number(selectedStation.data.devis_ref) == 0) && $formTool.getFormData('proc').type_garantie == 'hors_garantie'">
                                                <div class="mt-2 mr-5 font-light text-orange-600">
                                                    <i class="mr-1 fas fa-triangle-exclamation"></i> {{$t('form.stations.tarifs_non_communiques_des_frais_sont_a_prevoir')}}
                                                </div>
                                            </div>
                                            <div class="font-bold text-green-600" v-else-if="(selectedStation.data.mo + selectedStation.data.deplacement + selectedStation.data.devis_ref == 0) || $formTool.getFormData('proc').type_garantie == 'garantie'">
                                                {{$t('form.stations.gratuit')}}
                                            </div>
                                            <div class="text-xs" v-else>
                                                <div class="text-sm font-bold text-red-500" v-if="selectedStation.data.accompte > 0">{{$t('form.stations.accompte')}}: {{selectedStation.data.accompte}} €</div>
                                                <div class="text-sm font-bold text-red-500" v-if="selectedStation.data.mo > 0">{{$t('form.stations.main_d_oeuvre')}}: {{selectedStation.data.mo}} €</div>
                                                <div class="text-sm font-bold text-red-500" v-if="selectedStation.data.deplacement > 0">{{$t('form.stations.deplacement')}}: {{selectedStation.data.deplacement}} €</div>
                                                <div class="text-sm font-bold text-red-500" v-if="selectedStation.data.devis_ref > 0">{{$t('form.stations.devis_refuse')}}: {{selectedStation.data.devis_ref}} €</div>
                                            </div>
                                            <a href="https://www.label-qualirepar.fr/le-label/" target="_blank" v-if="selectedStation.data.qualirepar > 0 && $formTool.getFormData('proc').type_garantie == 'hors_garantie'">
                                                <hr class="my-4">
                                                <div class="flex items-center p-4 bg-gray-100 border rounded-xl">
                                                    <img class="h-10 mx-auto" src="https://disticloudfiles.net/img/savinfo/default/quali-repar.png">
                                                    <div class="ml-3">
                                                        <div class="font-bold text-green-600">{{$t('form.stations.bonus_reparation')}}: {{selectedStation.data.qualirepar}} €</div>
                                                        <p class="mt-0.5 font-light">{{$t('form.stations.aide_financee_par_les_eco_organismes_pour_inciter_les_francais_a_reparer_leurs_appareils')}}</p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                    </div>

                                    <!-- Adresse -->
                                    <div class="mt-4">
                                        <div class="text-sm font-bold">
                                            <i class="mr-1 fas fa-home"></i> {{$t('form.stations.adresse')}}
                                        </div>
                                        <div class="p-5 mt-2 text-xs border rounded-xl">
                                            <div>{{selectedStation.data.adresse}}</div>
                                            <div>{{selectedStation.data.ville + ', ' + selectedStation.data.cp}}</div>
                                        </div>
                                    </div>

                                    <!-- Contact -->
                                    <div class="mt-4" v-if="selectedStation.data.tel || selectedStation.data.mail">
                                        <div class="text-sm font-bold">
                                            <i class="mr-1 fas fa-phone"></i> {{$t('form.stations.contact')}}
                                        </div>
                                        <div class="p-5 mt-2 text-xs border rounded-xl">
                                            <div v-if="selectedStation.data.tel">{{$t('form.stations.telephone')}}: <span v-if="selectedStation.data.tel[0] != '0'">0</span>{{selectedStation.data.tel}}</div>
                                            <div v-if="selectedStation.data.mail">{{$t('form.stations.email')}}: {{selectedStation.data.mail}}</div>
                                        </div>
                                    </div>

                                    <!-- Avis -->
                                    <div v-if="$formTool.getFormData('proc').type_garantie == 'hors_garantie' && (selectedStation && selectedStation.google && selectedStation.google.reviews)" class="mt-4">
                                        <div class="text-sm font-bold">
                                            <i class="mr-1 fas fa-comments"></i> {{$t('form.stations.avis')}}
                                        </div>
                                        <div style="max-height: 500px;" class="p-5 mt-2 overflow-y-auto text-xs border rounded-xl">
                                            <div v-for="(review, reviewIndex) in selectedStation.google.reviews" :key="'review-' + reviewIndex" class="p-4 border-b">
                                                <div class="font-bold">{{review.author_name.split(' ')[0]}}</div>
                                                <star-rating
                                                v-if="selectedStation.google && selectedStation.google.rating"
                                                class="mb-2"
                                                v-model="review.rating"
                                                :read-only="true"
                                                :increment="0.1"
                                                :star-size="13"
                                                text-class="hidden"
                                                ></star-rating>
                                                <div>
                                                    {{review.text}}
                                                </div>
                                                <div class="my-2 text-2xs opacity-60">{{convertTimestamp(review.time)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <!-- Right map -->
                    <sav-map
                    class="hidden block mt-3 lg:block lg:w-1/2"
                    custom-class="shadow my-rounded"
                    v-if="!selectedStation && markers && markers.length > 0"
                    :position="{
                        longitude: longitude,
                        latitude: latitude,
                        zoom: zoom
                    }"
                    :markers="markers"
                    :selected-marker="selectedMarker"
                    @marker-clicked="markerClicked"
                    ></sav-map>
                </div>
            </template>
        </sav-fold-card>            
    </div>
</template>

<script>
import moment from 'moment'

import StarRating from 'vue-star-rating'

import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

import SavSpinner from '../../../../components/SavSpinner.vue'

export default {
    components: { SavSpinner, StarRating },
    name: 'get-stations',
    extends: FormCardExtension,

    data() {
        return {
            markers: null,
            longitude: null,
            latitude: null,
            cp: null,
            zoom: 10,

            selectedStation: null,
            canDisplayStationInfos: false,

            selectedMarker: null
        }
    },

    computed: {
        cardLabel() {
            let setCase = JSON.parse(this.$formTool.getFormData('set-case'))
            if (setCase.process == 'iad') {
                return this.$t('form.stations.selectionnez_la_station_technique')
            }
            return this.$t('form.stations.selectionnez_le_destinataire')
        }
    },

    methods: {
        async init() {
            // Init data before request
            let id_app = this.$formTool.getFormData('device')[0].value.id
            let id_case = JSON.parse(this.$formTool.getFormData('set-case')).id_case
            this.markers = []
            this.longitude = "2.213749"
            this.latitude = "46.227638"

            if (this.$formTool.getFormData('client-address')) {
                let address = this.$formTool.getFormData('client-address')
                this.longitude = address.longitude
                this.latitude = address.latitude
                this.cp = address.cp
            }

            // Get data
            this.loading = true
            let response = await apiService.post('getsta', {
                id_app: id_app,
                longitude: this.longitude,
                latitude: this.latitude,
                cp: this.cp,
                id_case: id_case
            })

            if (response.data.posts.post && response.data.posts.post.length <= 0) {
                this.$parent.removeLastBlock()
                this.nextBlock = this.$formTool.blockData(this.$options.name).next.end
                this.emitChange()
            // } else if (response.data.posts.post && response.data.posts.post.length == 1) {
                // this.end(response.data.posts.post[0])
                // this.$parent.hideBlockByName(this.$options.name)
            } else {
                this.data = response.data.posts.post.map(marker => ({
                    ...marker,
                    total: Number(marker.mo) + Number(marker.deplacement)
                }))

                // Make random id for each marker
                let makeid = (length) => {
                    var result = ''
                    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
                    var charactersLength = characters.length
                    for (var i = 0; i < length; i++) {
                        result += characters.charAt(Math.floor(Math.random() * charactersLength))
                    }
                    return result
                }

                // Fill default data
                this.data.forEach((item, index) => {
                    item.map_id = index
                    if (item.lon && item.lat) {
                        this.markers.push({
                            longitude: item.lon,
                            latitude: item.lat,
                            data: item,
                            type: item.type,
                            color: null,
                            map_id: index,
                            label: `
                                <div class="mb-1 font-bold"><i class="mr-1 fas fa-shop"></i>${item.nom}</div>
                                <div class="text-xs opacity-70">
                                    ${item.tel ? '<div>Tel: ' + item.tel + '</div>' : ''}
                                    ${item.mail ? '<div>Email: ' + item.mail + '</div>' : ''}
                                </div>
                                <hr class="my-3" />
                                <div>
                                    <div class="mb-1 font-bold"><i class="mr-1 fas fa-home"></i> Adresse </div>
                                    <span class="font-light">${item.adresse + ' ' + item.cp + ' ' + item.ville}</span>
                                </div>
                            `,
                            id: makeid(20)
                        })
                    }
                })

                // Set google reviews
                this.data.forEach((item) => {
                    if (item.google) {
                        item.google = JSON.parse(item.google).result
                    }
                })

                // Set longitude / latitude
                this.longitude = this.markers[0].longitude
                this.latitude = this.markers[0].latitude
    
                if (this.markers && this.markers.length == 1) {
                    // await this.end(this.markers[0], true)
                }
            }

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                const lastSelectedStation = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                let markerExists = this.markers.find((marker) => marker.data.id == lastSelectedStation.data.id)

                if (markerExists) {
                    this.nextBlock = this.getNextBlock()
                    this.selected = lastSelectedStation
                    markerExists.google = this.data.find((marker) => marker.id == lastSelectedStation.data.id).google
                    this.selectedStation = markerExists
                    this.canDisplayStationInfos = true
                }
            }

            this.loading = false
        },

        async end(callbackData) {
            let saveValue = {data: {
                id: callbackData.data.id,
                nom: callbackData.data.nom,
                adresse: callbackData.data.adresse,
                cp: callbackData.data.cp,
                ville: callbackData.data.ville
            }}

            this.$formTool.addFormData(this.$options.name, saveValue)
            this.nextBlock = this.getNextBlock()

            let response = await apiService.post('setsta', {
                id_sta: callbackData.data.id_sta,
                garantie: JSON.parse(this.$formTool.getFormData('set-case')).garantie,
                id_conso: this.$crypto.decrypt(localStorage.getItem('client_id')),
                id_case: JSON.parse(this.$formTool.getFormData('set-case')).id_case
            })

            this.$formTool.addFormData('transporter', response.data.posts.post)

            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
            if (this.manualAddress) {
                this.saveAddressInAccount()
            }
        },

        getNextBlock() {
            let process = JSON.parse(this.$formTool.getFormData('set-case')).process
            if (process == 'sav') {
              return this.$formTool.blockData(this.$options.name).next.sav
            }
            if (process == 'iad') {
              return this.$formTool.blockData(this.$options.name).next.iad
            }
        },

        markerClicked(marker) {
            this.selectMarker(marker)
        },

        async selectMarker(marker) {
            this.canDisplayStationInfos = false
            let stationGoogle = await apiService.post('getinfosta', {
                placeid: marker.data.placeid
            })
            this.selectedStation = marker
            this.selectedStation.google = JSON.parse(stationGoogle.data.posts.post).result
            this.$refs.leftSide.scrollTop = 0
            this.canDisplayStationInfos = false
            this.canDisplayStationInfos = true
        },

        convertTimestamp(timestamp) {
            return moment.unix(timestamp).format("DD/MM/YYYY");
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/Components/GetStationsCard.vue